export default "__VITE_ASSET__DOz1Ge2k__"